import { ErrorHandler, Injectable } from '@angular/core'
import * as Sentry from '@sentry/angular'

const CHUNK_ERROR_PATTERNS = [
	/importing a module script failed/i,
	/failed to fetch dynamically imported module/i,
	/loading chunk .* failed/i,
	/NG0750/,
]

const RELOAD_FLAG = 'mos-chunk-reload'

function isChunkLoadError(error: unknown): boolean {
	const message = error instanceof Error ? error.message : String(error)
	return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

// After a deploy, a stale tab can reference a JS chunk hash that no longer exists on the
// server (MOS-WEB-B), or an @defer block can fail to load its dependencies for the same
// reason with no @error block configured (MOS-WEB-A9). Reloading picks up the fresh
// index.html + matching chunks. Guarded by sessionStorage (once per tab) so a genuinely
// broken deploy doesn't reload-loop forever.
@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
	private readonly sentryHandler = Sentry.createErrorHandler()

	handleError(error: unknown): void {
		if (isChunkLoadError(error) && !sessionStorage.getItem(RELOAD_FLAG)) {
			sessionStorage.setItem(RELOAD_FLAG, '1')
			window.location.reload()
			return
		}

		this.sentryHandler.handleError(error)
	}
}
